import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

// Novo conjunto de ícones em SVG inline (sem depender de arquivos externos)
function NavIcon({ name, color = '#374151', size = 18 }) {
  const p = { fill: 'none', stroke: color, strokeWidth: 1.6, strokeLinecap: 'round', strokeLinejoin: 'round' };
  const paths = {
    dashboard: <><rect x="3.5" y="3.5" width="7.5" height="7.5" rx="1.6" {...p}/><rect x="13" y="3.5" width="7.5" height="4.5" rx="1.6" {...p}/><rect x="13" y="10" width="7.5" height="10.5" rx="1.6" {...p}/><rect x="3.5" y="13" width="7.5" height="7.5" rx="1.6" {...p}/></>,
    orcamentos: <><path d="M6.5 3h8l3 3.2V21h-11z" {...p}/><path d="M8.5 8.5h6.5M8.5 12h6.5M8.5 15.5h4.5" {...p}/></>,
    produtos: <><path d="M12 3.2l7.5 3.7v10.2L12 20.8l-7.5-3.7V6.9z" {...p}/><path d="M4.5 6.9L12 10.6l7.5-3.7M12 10.6v10.2" {...p}/></>,
    relatorios: <><path d="M4 20h16" {...p}/><rect x="6" y="12" width="3" height="8" rx="0.8" {...p}/><rect x="10.5" y="7" width="3" height="13" rx="0.8" {...p}/><rect x="15" y="15" width="3" height="5" rx="0.8" {...p}/></>,
    pessoa: <><circle cx="12" cy="8" r="3.4" {...p}/><path d="M4.7 20c1.1-4.2 4.1-6.4 7.3-6.4s6.2 2.2 7.3 6.4" {...p}/></>,
    agenda: <><rect x="3.5" y="5" width="17" height="15" rx="2.2" {...p}/><path d="M3.5 9.8h17M8 3v4M16 3v4" {...p}/></>,
    loja: <><path d="M5.5 8h13l-1 12.2h-11z" {...p}/><path d="M8.5 8a3.5 3.5 0 017 0" {...p}/></>,
    ponto: <><circle cx="12" cy="12" r="8.5" {...p}/><path d="M12 7.5V12l3.2 2" {...p}/></>,
    log: <><path d="M5 5h14v14H5z" {...p}/><path d="M8 9.5h8M8 13h8M8 16.5h5" {...p}/></>,
    empresa: <><path d="M4.5 21V4.5h9V21" {...p}/><path d="M13.5 21V9.5H19.5V21" {...p}/><path d="M7.5 8h1M7.5 11.5h1M7.5 15h1M10.5 8h1M10.5 11.5h1M10.5 15h1" {...p}/></>,
    sair: <><path d="M9.5 4.5H5.2v15h4.3" {...p}/><path d="M14 12H3.5" {...p}/><path d="M10.7 8.2l3.8 3.8-3.8 3.8" {...p}/></>,
    hamburguer: <path d="M4 7h16M4 12h16M4 17h16" {...p}/>,
    sino: <><path d="M6 10.2a6 6 0 1112 0c0 4.8 1.8 6 1.8 6H4.2s1.8-1.2 1.8-6z" {...p}/><path d="M10.2 20a1.9 1.9 0 003.6 0" {...p}/></>,
    config: <><circle cx="12" cy="12" r="3" {...p}/><path d="M19 12a7 7 0 00-.2-1.6l2-1.5-2-3.4-2.3.9a7 7 0 00-2.8-1.6L13.3 2h-2.6l-.4 2.8a7 7 0 00-2.8 1.6l-2.3-.9-2 3.4 2 1.5A7 7 0 004.9 12a7 7 0 00.2 1.6l-2 1.5 2 3.4 2.3-.9a7 7 0 002.8 1.6l.4 2.8h2.6l.4-2.8a7 7 0 002.8-1.6l2.3.9 2-3.4-2-1.5c.1-.5.2-1 .2-1.6z" {...p}/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{flexShrink:0}}>
      {paths[name] || null}
    </svg>
  );
}

export default function MenuPainelAdmin(){

  const TenancyColor = localStorage.getItem('localcolorusers')

  const tenancylocal = localStorage.getItem('ClienteTenancy')
  const usernivel = localStorage.getItem('usernivel') 
  const nomelog = JSON.parse(localStorage.getItem('ItemUsers'));

  //console.log(nomelog.email)
  axios.defaults.headers.common['idtenancy'] = tenancylocal;
  axios.defaults.headers.common['nome'] = nomelog.email;
  const navigate = useNavigate();
  const [selected, setSelected] = useState(localStorage.getItem('selected') || '');

  const [openlog,setOpenlog] = useState(false)
  const [openmenu,setOpenMenu] = useState(false)
  const [opennotifica,setOpennotifica] = useState(false)
  
  const [datanotifica,setDatanotifica]=useState([])
  const [datalog,setDatalog]=useState([])

  const initialValues={ // DEFININDO UMA CONST PARA O STATE INICIAL 
    titulo: '',	descricao: '',	troco: '',bairro:'0',rua:'0',numero:'0',complemento:'0',observacoes:'null',	cliente: '', nome:''
  }
  
  const [values, setValues]=useState(initialValues) // INICIANDO UM STATE
  const handleClick = (item, path) => {
    setSelected(item);
    localStorage.setItem('selected', item); // Salva no localStorage
    navigate(path);
  };
  function onChange(ev) {//ALTERAR OS STATES DOS INPUTS
    const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV
    setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
  }
  useEffect(()=>{
    rec();
    if ((window.screen.availHeight < 1234) &&(window.screen.availWidth < 1234)){
      //console.log("tela pequena")
    }
  else{
    setOpenMenu(true)
  //console.log("tela pequena")
  }
  setSelected(localStorage.getItem('selected') || '');


    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    const deslogar =()=>{
      localStorage.removeItem('keyItemNameg');
      localStorage.removeItem('keyItemName');
      localStorage.removeItem('ItemUsers')
      localStorage.removeItem('usernivel')
      window.location.href = "/";
    }

    function rec(){
      axios.get('api/log/tenancy').then(resp=>{
        const logmax = resp.data.map(loglop=>loglop.id_log);
        const maxlog = Math.max(...logmax);

        setDatalog(resp.data)
        const notificLenght = localStorage.getItem('logLenght') || 0; // Se não houver valor no localStorage, defina como 0
        if (maxlog > notificLenght) {
          alert("Um cliente abriu o link de orçamento, confira no meu de Log");
          localStorage.setItem('logLenght', maxlog); // Atualiza o maior ID no localStorage
        } else {
          localStorage.setItem('logLenght', maxlog); // Garante que o localStorage seja sempre atualizado
        }
      })
      

      axios.get('/api/notificacoes').then(resp => { 
        const notificacoes = resp.data.map(notificacao => notificacao.id_notificacao); // Extrai os IDs das notificações
        const maxId = Math.max(...notificacoes); // Encontra o maior id_notificacao
        const invalid = {ERRO: 'token invalido 3'}&&{ERRO: 'token invalido 2'};
        //console.log(resp)
        if (JSON.stringify(resp.data[0]) === JSON.stringify(invalid)) {
          navigate('/login');
          window.location.reload(true);
        }
        else{
          setDatanotifica(resp.data);
        }
        
        const notificLenght = localStorage.getItem('notificLenght') || 0; // Se não houver valor no localStorage, defina como 0
        if (maxId > notificLenght) {
          alert("Você tem uma nova notificação no menu");
          localStorage.setItem('notificLenght', maxId); // Atualiza o maior ID no localStorage
        } else {
          localStorage.setItem('notificLenght', maxId); // Garante que o localStorage seja sempre atualizado
        }
      });
      
      
    }
    function onSubmit(ev){//CADASTRAR NO BANCO DE DADOS, obs refatorado para tirar o if e else e usar o. ternario edit e cadastrar
      ev.preventDefault();
      if(values.descricao===''||values.titulo===''){
          alert("Atencao, preencha todos os campos!")
           }else{
          axios.post('/api/notificacoes',values).then(()=>{
              setValues(initialValues);
              rec();
          })
      }
  }
  const exclui = function(id){//EXCLUI
    axios.delete('/api/notificacoes/' + id).then(()=>{
        rec();
        setValues(initialValues)
    })
  }
    const finalnotifica = datanotifica.map(namesString=>
      <div key={namesString.id_notificacao} className="column ma10b0 linha">
        <label className="fs08em c1 fb w90 ma5">{namesString.titulo}</label>
        <label className="w90 fs08em">{namesString.descricao}</label>
        <label className="fs06em w90 fim pcb10 fb">{namesString.createdAt}</label>
        {tenancylocal==='autodisel'&&<div className="w100 row end"><button className='w40 fs06em fb btn04' onClick={()=>exclui(namesString.id_notificacao)}>Excluir</button></div>}
      </div>
      
    )
    const datalogfilter = datalog.filter(datalog => datalog.nome !== null);
    const finallog = datalogfilter?.map(namesString=>
      <div key={namesString.id_notificacao} className="column ma10b0 linha">
        <label className="fb fs08em c1 w90 ma5">{namesString.nome?`${namesString.nome}`:'um cliente'}</label>
        <label className="w90 fs08em">Acessou o link do orçamento</label>
        {/*<label className="w90 fs06em pcb10">{namesString.url}</label>*/}
        <label className="w90 fs08em">{namesString.device?.slice(0,40)}</label>
        <label className="fs06em w90 fim pcb10 fb">
          {new Date(namesString.createdAt).toLocaleString('pt-BR', {
            timeZone: 'America/Sao_Paulo', // Substitua pelo fuso horário que você deseja
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
          })}
        </label>
      </div> 
    )
   // console.log(datanotifica)
    return(
      <>
      <div className="posifixedinicio top0 left0 we40px pp z16 bt2 desktop-none">          
              {
                openmenu
                ?
                <div alt="menu lateral" 
                onClick={() => {
                  setOpenMenu(false);
                  setOpennotifica(false);
                  setOpenlog(false);
                }} >
                    <div className="w80 h5 column around ma10b0">
                      <div  style={{height:'4px',backgroundColor:TenancyColor}} className="w80 b5"></div>
                      <div  style={{height:'4px',backgroundColor:TenancyColor}} className="w80 b5"></div>
                      <div  style={{height:'4px',backgroundColor:TenancyColor}} className="w80 b5"></div>
                      <label className="fs06em">Menu</label>
                    </div>
                
                </div>
                :
                <div 
                  className="w100 " 
                  onClick={() => {
                    setOpenMenu(true);
                    setOpennotifica(false);
                    setOpenlog(false);
                  }} 
                >
                   <div className="w80 h5 column around ma10b0">
                      <div  style={{height:'4px',backgroundColor:TenancyColor}} className="w80 b5"></div>
                      <div  style={{height:'4px',backgroundColor:TenancyColor}} className="w80 b5"></div>
                      <div  style={{height:'4px',backgroundColor:TenancyColor}} className="w80 b5"></div>
                      <label className="fs06em">Abrir</label>
                    </div>
                </div>
                }
      </div>
      <div className="w20 h90 cont-circ3 column cell-none cell-margin10 ">
        
      </div>
      
      
      <div className="w20 desktop-height-100 cont-circ3 row cell-tamanho cell-margin10 posifixedinicio z15">
        
       
       
              
        {openlog&&<>
          <div className="w100 h100 fundo-opaco  posiabstop0 rigth0 top0 z1 desktop-none" onClick={()=>{setOpenlog(false); setOpenMenu(false); setOpennotifica(false)}}>
                
          </div>
          <div className="w100 b2 column around he100 z4">
            <div className="w90 h100 column center" style={{ overflowY: 'auto', height: '100%' }}>      
                  <div className="w100 he100 pcb50" style={{ overflowY: 'auto' }}>
                    <div className="w100 ma25b0">
                      <label>Registro de Log {datalogfilter.length}</label>
                    </div>
                {finallog}
              </div>
            </div>
          </div>
        
        </>
        }
        {opennotifica&&<>
          <div className="w100 h100 fundo-opaco  posiabstop0 rigth0 top0 z1 desktop-none" onClick={()=>{setOpenlog(false); setOpenMenu(false); setOpennotifica(false)}}>
                
          </div>
          <div className="w85 b2 column around he100 z4">

          <div className="w90 h100 column center" style={{ overflowY: 'auto', height: '100%' }}>
            
            <div className="w100 he100 pcb50" style={{ overflowY: 'auto' }}>
              <div className="w100 ma25b0">
                <label>Registro de notificações {datanotifica.length}</label>
              </div>
              
              {tenancylocal==='autodisel'&&
              <form onSubmit={onSubmit}>
                <div className="w90">
                  <label>Titulo</label>
                   <input type="text" name="titulo" onChange={onChange} value={values.titulo} autoComplete="off"></input>
                </div>
                <div className="w90">
                  <label>Subtitulo</label>
                  <input type="text"  name="descricao"  onChange={onChange} value={values.descricao} autoComplete='off'></input>
                </div>
                <div className="w90">
                  <input type="submit"/>
                </div>
              </form>}
              {finalnotifica}
            </div>
          </div>
        </div>
        </>
        }
        
        {openmenu&&<>
          <div className="w100 h100 fundo-opaco  posiabstop0 rigth0 top0 z1 desktop-none" onClick={()=>{setOpenlog(false); setOpenMenu(false); setOpennotifica(false)}}>
              
          </div>
          <div className="w85 column around h100 z4 b1">
            
            <div className=" cell-none w90">
              <span className="fb c2">
                {tenancylocal.charAt(0).toUpperCase() + tenancylocal.slice(1)}
              </span>
             
            </div>
            {//<label onClick={()=>setOpenMenu(false)} className="pp w90 h7 center column b27">Fechar Menu</label>
            }
            <div className="w90 column center">
            {usernivel>=20&&
               <div
                style={{backgroundColor: selected === 'dashboard' ? (TenancyColor?TenancyColor : "#C1C1C1"):'transparent'}}
                className="nav-item"
                onClick={() => handleClick('dashboard', '/painel')}
              >
                <NavIcon name="dashboard" color={selected === 'dashboard' ? '#FFF' : '#374151'}/>
                <span style={{color:selected === 'dashboard' ? '#FFF' : '#7e7e80', fontWeight:selected === 'dashboard' ? 700 : 500}} className="nav-label no-hover pp">Dashboard</span>
              </div>
            }{/*
              <div
                className={`w100 row center ${selected === 'novo' ? 'selected' : ''} cell-paddingcb10px`}
                onClick={() => handleClick('novo', '/adminvendarapida')}
              >
                  {/*<img src={IconNovoOrcamento} alt="icone de painel" />}
                <span className="fb w79 pc10l5 no-hover pp fs09em">Novo Orçamento</span>
              </div>
              */}
             <div
                style={{backgroundColor: selected === 'orcamentos' ?  (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                className="nav-item"
                onClick={() => handleClick('orcamentos', '/adminpedido')}
              >
                <NavIcon name="orcamentos" color={selected === 'orcamentos' ? '#FFF' : '#374151'} />
                <span style={{color:selected === 'orcamentos' ? '#FFF' : '#7e7e80', fontWeight:selected === 'orcamentos' ? 700 : 500}} className="nav-label no-hover pp">Orçamentos / Vendas</span>
              </div>

              <div
                style={{backgroundColor: selected === 'produtos' ?  (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                className="nav-item"
                onClick={() => handleClick('produtos', '/adminproduto')}
              >
                <NavIcon name="produtos" color={selected === 'produtos' ? '#FFF' : '#374151'} />
                <span style={{color:selected === 'produtos' ? '#FFF' : '#7e7e80', fontWeight:selected === 'produtos' ? 700 : 500}} className="nav-label no-hover pp">Produtos e Serviços</span>
              </div>
              

              {usernivel>=20&&<>
              <div
                style={{backgroundColor: selected === 'caixa' ?  (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                className="nav-item"
                onClick={() => handleClick('caixa', '/adminvendaprodutoservico')}
              >
                <NavIcon name="relatorios" color={selected === 'caixa' ? '#FFF' : '#374151'}/>
                <span style={{color:selected === 'caixa' ? '#FFF' : '#7e7e80', fontWeight:selected === 'caixa' ? 700 : 500}} className="nav-label no-hover pp">Relatórios</span>
              </div>
              </>}

              {usernivel>=20&&
              <div
                style={{backgroundColor: selected === 'fornecedor' ?  (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                className="nav-item"
                onClick={() => handleClick('fornecedor', '/adminclientefornecedor')}
              >
                <NavIcon name="pessoa" color={selected === 'fornecedor' ? '#FFF' : '#374151'}/>
                <span style={{color:selected === 'fornecedor' ? '#FFF' : '#7e7e80', fontWeight:selected === 'fornecedor' ? 700 : 500}} className="nav-label no-hover pp">Fornecedor</span>
              </div>
              }
              <div
                style={{backgroundColor: selected === 'funcionario' ?  (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                className="nav-item"
                onClick={() => handleClick('funcionario', '/adminclientefuncionario')}
              >
                <NavIcon name="pessoa" color={selected === 'funcionario' ? '#FFF' : '#374151'}/>
                <span style={{color:selected === 'funcionario' ? '#FFF' : '#7e7e80', fontWeight:selected === 'funcionario' ? 700 : 500}} className="nav-label no-hover pp">Funcionario</span>
              </div>

             <div
                style={{backgroundColor: selected === 'clientes' ?  (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                className="nav-item"
                onClick={() => handleClick('clientes', '/admincliente')}
              >
                <NavIcon name="pessoa" color={selected === 'clientes' ? '#FFF' : '#374151'}/>
                <span style={{color:selected === 'clientes' ? '#FFF' : '#7e7e80', fontWeight:selected === 'clientes' ? 700 : 500}} className="nav-label no-hover pp">Clientes</span>
              </div>

              
              
              {usernivel>=20&&
              
               <div
                style={{backgroundColor: selected === 'custos' ?  (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                className="nav-item"
                onClick={() => handleClick('custos', '/admincustoempresa')}
              >
                <NavIcon name="pessoa" color={selected === 'custos' ? '#FFF' : '#374151'}/>
                <span style={{color:selected === 'custos' ? '#FFF' : '#7e7e80', fontWeight:selected === 'custos' ? 700 : 500}} className="nav-label no-hover pp">Custos</span>
              </div>
              
              }
              {usernivel>=20&&
              <div
                  className="nav-item"
                  style={{backgroundColor: selected === 'admialojavirtual' ? (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                  onClick={() => handleClick('admialojavirtual', '/admialojavirtual')}
                >
                  <NavIcon name="loja" color={selected === 'admialojavirtual' ? '#FFF' : '#374151'}/>
                  <span className="nav-label no-hover pp" style={{color:selected === 'admialojavirtual' ? '#FFF' : '#7e7e80', fontWeight:selected === 'admialojavirtual' ? 700 : 500}}>Loja Online</span>
                </div>
              }
              {/*
              <label className="nav-section-label w100">Plano Pro</label>
              <div className="w100 sidebar-group">
                <div
                  className="nav-item"
                  style={{backgroundColor: selected === 'agenda' ? (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                  onClick={() => handleClick('agenda', '/admiagenda')}
                >
                  <NavIcon name="agenda" color={selected === 'agenda' ? '#FFF' : '#374151'}/>
                  <span className="nav-label no-hover pp" style={{color:selected === 'agenda' ? '#FFF' : '#7e7e80', fontWeight:selected === 'agenda' ? 700 : 500}}>Agenda</span>
                </div>
                

                {usernivel>=20&&
                <div
                  className="nav-item"
                  style={{backgroundColor: selected === 'ponto' ? (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                  onClick={() => handleClick('ponto', '/adminponto')}
                >
                  <NavIcon name="ponto" color={selected === 'ponto' ? '#FFF' : '#374151'}/>
                  <span className="nav-label no-hover pp" style={{color:selected === 'ponto' ? '#FFF' : '#7e7e80', fontWeight:selected === 'ponto' ? 700 : 500}}>Relógio de Ponto</span>
                </div>
                }
              </div>
              */}
              {tenancylocal==='autodisel'&&
                <div
                className="nav-item"
                style={{backgroundColor: selected === 'log' ? (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                onClick={() => handleClick('log', '/adminlog')}
              >
                  <NavIcon name="log" color={selected === 'log' ? '#FFF' : '#7e7e80'}/>
                <span className="nav-label no-hover pp" style={{color:selected === 'log' ? '#FFF' : '#374151', fontWeight:selected === 'log' ? 700 : 500}}>Log</span>
              </div>
              }
               {usernivel>=20&&
               <div
                style={{backgroundColor: selected === 'empresa' ?  (TenancyColor?TenancyColor : "#C1C1C1") : 'transparent'}}
                className="nav-item"
                onClick={() => handleClick('empresa', '/admindadosempresa')}
              >
                <NavIcon name="empresa" color={selected === 'empresa' ? '#FFF' : '#7e7e80'}/>
                <span style={{color:selected === 'empresa' ? '#FFF' : '#7e7e80', fontWeight:selected === 'empresa' ? 700 : 500}} className="nav-label no-hover pp">Dados Empresa</span>
              </div>
              
              }
               {/* usernivel>=20&&
                  <div
                    className={`w100 row center ${selected === 'financeiro' ? 'selected' : ''}  cell-paddingcb10px`}
                    onClick={() => handleClick('financeiro', '/adminfinanceirotenancy')}
                  >
                    {/*<img src={IconEmpresa} alt="icone de painel" /> }
                    <span className="fb w70 pc10l5 no-hover pp fs09em">Financeiro</span>
                    <div className="w7 b27 column center cont-circ7 fs06em fb pp"> Novo</div>
                  </div>
                */}

              

              <div className="w100 nav-item">
                <NavIcon name="sair" color="#374151"/>
                <Link to="/" className="nav-label pp" style={{color:'#7e7e80'}} onClick={deslogar}>
                  Sair do app
                </Link>
              </div>

             

            
            
            </div>
            <label className="sidebar-footnote">Auto metricas &trade;</label>
            <div className="row around w80">
            
            
            <div
              className="pp"
              onClick={() => {
                setOpenMenu(true);
                setOpennotifica(false);
                setOpenlog(false);
              }}
            >
              <NavIcon name="hamburguer" size={22} color="#374151"/>
            </div>


            <div
              className="pp"
              onClick={() => {
                setOpennotifica(!opennotifica);
                setOpenMenu(false);
                setOpenlog(false);
              }}
            >
              <NavIcon name="sino" size={22} color="#374151"/>
            </div>
            <div
              className="pp"
              onClick={() => {
                setOpenlog(!openlog);
                setOpenMenu(false);
                setOpennotifica(false);
              }}
            >
              <NavIcon name="log" size={22} color="#374151"/>
            </div>
          </div>
          
          
        </div>
        </>
        }
        
        
      </div>
      </>
    )
}